import styled from '../../../../styles/styledComponents/themeComponents';

export const EmptyStateStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  gap: 20px;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  margin: 20px 0;

  p {
    color: #999;
    font-size: 14px;
    margin: 0;
  }
`;

export const ButtonListStyle = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 32px;
  padding: 24px 8px 24px 0;
  border-top: 1px solid #efefef;
`;
